module.exports = __webpack_public_path__ + "static/img/logo.c92b9323.png";